export const BEM_BLOCK_NAME = 'release_notes_dialog';
